<template>
  <nav class="navbar navbar-white">
    <router-link to="/admin" class="navbar-brand">
      <img src="~@/assets/svg/logo/logo-biz-admin.svg" class="img-responsive" alt="Bizhaezoom Logo">
    </router-link>
    <div class="collapse navbar-collapse">
      <ul class="navbar-nav" v-if="menuList.length > 0">
        <li :class="['nav-item', {'active': menu.code === currentTab }]"
            v-for="menu in menuList"
            :key="menu.code">
          <router-link :to="menu.path" class="nav-link">{{ menu.name }}</router-link>
        </li>
      </ul>
      <ul class="navbar-nav navbar-right padding-0">
        <li v-if="user.id" class="nav-item-sub padding-0">
          <div class="nav-menu-hamburger collapsed">
            <i class="glyphicon glyphicon-menu-hamburger"></i>
          </div>
          <div class="nav-user-menu">
            <router-link to="/" target="_blank">비즈해줌</router-link>
            <a href="#" @click.prevent="$emit('logout')">로그아웃</a>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'admin-gnb',
    props: {
      currentTab: {
        type: String,
        default () {
          return ''
        }
      },
      menuList: {
        type: Array,
        default () {
          return []
        }
      }
    },
    computed: {
      ...mapGetters({
        user: 'user'
      })
    }
  }
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/components/gnb';
  .navbar-brand {
    width: 197px;
    padding: 24px 8px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminGnb.vue